module.exports = __webpack_public_path__ + "static/media/pov_whole_polytope_3_3_52.fcd8e65f.png";